import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import SaveLawTrackingWidget from '../../../widgets/saveLawTracking/SaveLawTrackingWidget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { GetLawFollowPage } from '../../../redux/actions/legal'

export default function SaveLawTracking() {
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async (litigationId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await GetLawFollowPage(litigationId)
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    // let litigationId = location.search.substring(1)
    let litigationId = sessionStorage.getItem('param')?.substring(1)

    console.log('litigationId : ', litigationId)

    handleGetSchema(litigationId)
  }, [])

  if (error) {
    return (
      <SidebarProposal isLegalManagement>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isLegalManagement>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isLegalManagement>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      <SaveLawTrackingWidget
        schema={schema}
        handleCallback={() => {
          handleGetSchema(sessionStorage.getItem('param')?.substring(1))
        }}
      />

      <br />
    </SidebarProposal>
  )
}
